import Avatar from "@material-ui/core/Avatar/Avatar";
import React from "react";
const tabConfig = [
  {
    columnTitle: "",
    dataField: ["component"],
    component: ({ values }) => {
      return <Avatar src={values.profilePhotoURL} variant="rounded" />;
    },
  },
  {
    columnTitle: "Full Name",
    dataField: ["fullName"],
  },
  {
    columnTitle: "Position",
    dataField: ["position"],
  },
  {
    columnTitle: "Description",
    dataField: ["description"],
  },
];

export default tabConfig;
